import { useMutation } from 'react-query';
import { getForgetPasswordPostRequest, getJumpCloudSsoCallbackRequest, getLoginPostRequest, getResetPasswordPostRequest } from './requests';
export var usePasswordResetRequest = function usePasswordResetRequest() {
    return useMutation(getForgetPasswordPostRequest);
};
export var usePasswordReset = function usePasswordReset() {
    return useMutation(getResetPasswordPostRequest);
};
export var useLogin = function useLogin() {
    return useMutation(getLoginPostRequest);
};
export var useJumpCloudSsoCallback = function useJumpCloudSsoCallback(tenant) {
    return useMutation(function (params) {
        return getJumpCloudSsoCallbackRequest(params, tenant);
    });
};
